import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { getInvoices, getSuperInvoices } from './api'

export const INVOICES_DEFAULT_PAGE_SIZE = 10

/* companyId switches the same list to the super endpoint, so one table renders
 * a company's payment history whether it is the caller's own or one staff are
 * looking at. */
export function useInvoices(
  page: number,
  pageSize = INVOICES_DEFAULT_PAGE_SIZE,
  companyId?: string
) {
  return useQuery({
    queryKey: companyId
      ? ['super', 'billing', companyId, 'invoice-list', page, pageSize]
      : ['billing', 'invoices', page, pageSize],
    queryFn: ({ signal }) =>
      companyId
        ? getSuperInvoices(companyId, page, pageSize, signal)
        : getInvoices(page, pageSize, signal),
    placeholderData: keepPreviousData
  })
}
